import { useState, useEffect } from 'react';

function extractQueryParams(): Record<string, string> {
  const q = window.location.search;
  if (!q) return {};

  return q
    .substring(1)
    .split('&')
    .reduce<Record<string, string>>((params, param) => {
      const [key, value] = param.split('=');
      params[decodeURIComponent(key)] = decodeURIComponent(value || '');
      return params;
    }, {});
}

export function useLocation() {
  const [pathname, setPathname] = useState(() => {
    const path = window.location.pathname;
    return path.endsWith('/') && path !== '/' ? path.slice(0, -1) : path;
  });
  const [queryParams, setQueryParams] = useState(extractQueryParams());

  useEffect(() => {
    const handleLocationChange = () => {
      const path = window.location.pathname;
      const cleanPath = path.endsWith('/') && path !== '/' ? path.slice(0, -1) : path;
      
      if (path !== cleanPath) {
        window.history.replaceState(null, '', cleanPath + window.location.search);
      }
      
      setPathname(cleanPath);
      setQueryParams(extractQueryParams());
    };

    window.addEventListener('popstate', handleLocationChange);
    window.addEventListener('pushstate', handleLocationChange);
    window.addEventListener('replacestate', handleLocationChange);
    
    return () => {
      window.removeEventListener('popstate', handleLocationChange);
      window.removeEventListener('pushstate', handleLocationChange);
      window.removeEventListener('replacestate', handleLocationChange);
    };
  }, []);

  return { pathname, queryParams };
}